// extracted by mini-css-extract-plugin
export var confirmReactivate = "reactivate-button_confirmReactivate__BtEmR";